import { Pill } from 'ui-components/components/pill';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import sectionStyle from '../orders-sidebar-section.module.less';
import style from './tags-section-content.module.less';

/**
 * @typedef {import('../../../../prop-types/tag').TagPropType} Tag
 */

/**
 * @param {object} props
 * @param {Tag[]} props.selectedTags
 * @param {(tag: Tag) => void} props.onTagToggled
 * @returns {JSX.Element}
 */
export const TagsSectionContent = ({ selectedTags, onTagToggled }) => {
  return (
    <div className={sectionStyle['order-sidebar-section-default-padding']}>
      {selectedTags.length ? (
        <div className={style['tags-container']}>
          {selectedTags.map((tag, index) => (
            <Pill key={`${tag.name}-${index}`} color={tag.hexColor} label={tag.name} onRemove={onTagToggled} theme='tag' />
          ))}
        </div>
      ) : (
        <Text className={style['no-tags-message']} textType={TextType.Paragraph} value={messages.noTags} />
      )}
    </div>
  );
};
